import axios from "axios";
import { api } from "../apiClient";

const API_SERVER_HOST = process.env.REACT_APP_API_SERVER_HOST;

const rest_api_key = process.env.REACT_APP_REST_API_KEY;
const login_redirect_uri = process.env.REACT_APP_LOGIN_REDIRECT_URI;
const signup_redirect_uri = process.env.REACT_APP_SIGN_UP_REDIRECT_URI;
const auth_code_path = process.env.REACT_APP_AUTH_CODE_PATH;
const access_token_url = process.env.REACT_APP_ACCESS_TOKEN_URL;
const client_secret = process.env.REACT_APP_CLIENT_SECRET;

export const getKakaoLoginLink = () => {
  return `${auth_code_path}?client_id=${rest_api_key}&redirect_uri=${login_redirect_uri}&response_type=code`;
};

export const getKakaoSignUpLink = () => {
  return `${auth_code_path}?client_id=${rest_api_key}&redirect_uri=${signup_redirect_uri}&response_type=code`;
};

export const getAccessTokenForLogin = async (authCode) => {
  const header = {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  };
  const params = new URLSearchParams();
  params.append("grant_type", "authorization_code");
  params.append("client_id", rest_api_key);
  params.append("redirect_uri", login_redirect_uri);
  params.append("code", authCode);
  params.append("client_secret", client_secret);

  const res = await axios.post(access_token_url, params, header);
  return res.data.access_token;
};

export const getAccessTokenForSignUp = async (authCode) => {
  const header = {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  };
  const params = new URLSearchParams();
  params.append("grant_type", "authorization_code");
  params.append("client_id", rest_api_key);
  params.append("redirect_uri", signup_redirect_uri);
  params.append("code", authCode);
  params.append("client_secret", client_secret);

  const res = await axios.post(access_token_url, params, header);

  console.log(res);
  return res.data.access_token;
};

export const registerMember = async (accessToken) => {
  return axios.get(`${API_SERVER_HOST}/user/register`, {
    params: { accessToken },
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
};

// ✅ HttpOnly 인증 전용
export const authLogin = async (kakaoAccessToken) => {
  return axios.get(`${API_SERVER_HOST}/auth/login`, {
    params: { kakaoAccessToken },
    withCredentials: true,
  });
};

export const authMe = async () => {
  return api.get("/auth/me", { skipAuthRedirect: true });
};

export const authLogout = async () => {
  return api.post("/auth/logout", null, { skipAuthRedirect: true });
};
